var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#checkbox_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "M12.573 5.5a1.003 1.003 0 0 1 .258 1.395l-3.676 5.347a1.005 1.005 0 0 1-1.482.192l-2.34-2.005a1.003 1.003 0 0 1 1.305-1.52l1.203 1.036a.34.34 0 0 0 .267.078.33.33 0 0 0 .233-.143l2.834-4.121a1.003 1.003 0 0 1 1.398-.258"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 17,
  height: 17,
  x: 0.5,
  y: 0.5,
  stroke: "#5f63ee",
  rx: 2.5
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "checkbox_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 10,
  x: 4,
  y: 4,
  fill: "#fff",
  rx: 3
})))));
export default SvgCheckbox;